import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const parkingBooking = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getParkings(userEmail, start, finish, siteId) {
    /*return Axios.get('http://localhost:3000/parking')*/
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/${siteId}/parkings?userEmail=${userEmail}&start=${start}&finish=${finish}`)
  },
  createBooking (parkingId, body) {
    return Axios.post(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/bookings`, body)
  },
  createBookingOfAnUser (parkingId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/parkings/${parkingId}/bookings`, body)
  },
  deleteParkingBookingOfAnUser (parkingId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/parkings/${parkingId}/bookings/${bookingId}`)
  },
  deleteParkingBooking (parkingId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/bookings/${bookingId}`)
  },
  markParkingBookingAsCheckedOutOfAnUser (parkingId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/parkings/${parkingId}/bookings/${bookingId}/checkout`)
  },
  markParkingBookingAsCheckedOut (parkingId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/bookings/${bookingId}/checkout`)
  },
  getAllParkingsWithTheirBookings (term, parkingId, date) {
    const config = utils.generateQueryString({term, parkingId, date}, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/active`, config)
  },
  markParkingBookingAsCheckedIn (parkingId, bookingId) {
    return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/parkings/${parkingId}/bookings/${bookingId}/checkin`)
  },
  saveVehicleUser (vehicle) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/users/vehicles`, vehicle)
  },
  getPrimaryVehicleAnotherPerson(userEmail) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/users/primaryVehicle?userEmail=${userEmail}`)
  },
  getUserVehicles(userEmail) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/users/vehicles?userEmail=${userEmail}`)
  },
}

export default parkingBooking
